import { InjectionToken } from '@angular/core';

/** CMS / bo-be API root (e.g. …/bo-be/api) — paths use `/polls`, not `/api/polls`, to avoid …/api/api/polls. */
export const SURVEY_API_BASE_URL = new InjectionToken<string>('SURVEY_API_BASE_URL');

export function normalizeSurveyApiBaseUrl(url: string): string {
  return (url || '').replace(/\/+$/, '');
}
